import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Counter from '../../elements/Counter.jsx'
import IconButton from '../../elements/IconButton.jsx'

import Dropdown from '../../elements/ReactSelectDropdown.jsx'
import Button from '../../elements/Button.jsx'

import Save from '../../media/icons/icons8-save-96.png'
import Edit from '../../media/icons/icons8-edit-96.png'
import Approve from '../../media/icons/icons8-approve-96.png'
import Deny from '../../media/icons/icons8-cancel-96.png'

import TextInput from '../../elements/TextInput.jsx'

import Delete from '../../media/icons/icons8-delete-96.png'

import ModalManager from '../../elements/ModalManager.jsx'
import AddSpiffee from './AddSpiffee.jsx'
import AddReserveInput from './AddReserveInput.jsx'

const Main = (props) => {
   
    console.log("Selected Report: ", props.saturdayReports[props.selectedReport])

    const [data, setData] = useState({
        dealership: {value: props.saturdayReports[props.selectedReport]?.dealership_ID?.id, label: props.saturdayReports[props.selectedReport]?.dealership_ID?.name},
        subagent: {value: props.saturdayReports[props.selectedReport]?.subagent_ID?.id, label: props.saturdayReports[props.selectedReport]?.subagent_ID?.first_name + ' ' + props.saturdayReports[props.selectedReport]?.subagent_ID?.last_name},
        admin: {value: props.saturdayReports[props.selectedReport]?.admin_ID?.id, label: props.saturdayReports[props.selectedReport]?.admin_ID?.name},
        contract_type: {value: props.saturdayReports[props.selectedReport]?.contract_type + ' - ' + props.saturdayReports[props.selectedReport]?.contract_subtype, label: props.saturdayReports[props.selectedReport]?.contract_type + ' - ' + props.saturdayReports[props.selectedReport]?.contract_subtype},
        quantity: {value: props.saturdayReports[props.selectedReport].quantity, label: props.saturdayReports[props.selectedReport].quantity},
        report_type: {value: props.saturdayReports[props.selectedReport]?.report_type, label: props.saturdayReports[props.selectedReport]?.report_type},
        code: props.saturdayReports[props.selectedReport]?.code,
        inside_sales: {value: props.saturdayReports[props.selectedReport]?.inside_sales, label: props.saturdayReports[props.selectedReport]?.inside_sales},

        gross: {value: props.saturdayReports[props.selectedReport]?.contract_gross, id: props.saturdayReports[props.selectedReport]?.contract_gross},
        net: {value: props.saturdayReports[props.selectedReport]?.net, id: props.saturdayReports[props.selectedReport]?.net},
        insideSales: props.saturdayReports[props.selectedReport]?.inside_sales ? {value: props.saturdayReports[props.selectedReport]?.net, id: props.saturdayReports[props.selectedReport]?.net}:{value: 0, id: 0},
        contractCount: {value: props.saturdayReports[props.selectedReport]?.total_contract_count, id: props.saturdayReports[props.selectedReport]?.total_contract_count},
    })

    function formatNumber(value) {
        try {
            // Attempt to convert the input to a number
            const num = parseFloat(value);
            // Check if the conversion resulted in a valid number
            if (!isNaN(num)) {
              // Use Intl.NumberFormat for US-style number formatting with two decimal places
              return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(num);
            } else {
              // Return a default value if the input is not a valid number
              return '0.00';
            }
          } catch (e) {
            // In case of any unexpected errors, return a default value
            return '0.00';
          }
    }

    const [reportSplits, setReportSplits] = useState(
        {
            gross: props.saturdayReports[props.selectedReport].contract_gross,
            net: props.saturdayReports[props.selectedReport].net,
            insideSales: props.saturdayReports[props.selectedReport].inside_sales_payout,
            contractCount: props.saturdayReports[props.selectedReport].total_contract_count
        }
    )

    const [addSpiffeeModal, setAddSpiffeeModal] = useState(false)
    const [addReserveInputModal, setAddReserveInputModal] = useState(false)

    console.log(data)

    const [allAdmins, setAllAdmins] = useState([])
    const [allDealers, setAllDealers] = useState([])
    const [allContractTypes, setAllContractTypes] = useState([])
    const [reportList, setReportList] = useState([])

    const onChange = (value, key) => {
        console.log(value, key)
        if (key === 'dealership')
        {
            setData(data => ({
                ...data,
                [key]: {value: value.value, label: value.label},
                contract_type: {value: '', label: ''},
                admin: {value: '', label: ''},
            }))
            loadAdmins(value.value);
        }
        if (key === 'admin')
        {
            setData(data => ({
                ...data,
                [key]: {value: value.value, label: value.label}
            }))
            loadContractTypes(value.value)
        }
        else
        {
            setData(data => ({
                ...data,
                [key]: {value: value.value, label: value.label}
            }))
        }
    }

    useEffect(() => {
        loadDealers(props.saturdayReports[props.selectedReport].subagent_ID?.id)
        loadAdmins(props.saturdayReports[props.selectedReport].dealership_ID?.id)
        loadContractTypes(props.saturdayReports[props.selectedReport].admin_ID?.id)
        loadReportTypes()
    },[])

    const loadDealers = (id) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        props.tokenSafeAPIRequest('/user/full/' + id, requestOptions, '', (result) => {
            let tempDealersList = []
            result.dealership_connections.map((dealer) => {
                tempDealersList.push({value: dealer.dealership_ID?.id, label: dealer.dealership_ID?.name})
            })
            setAllDealers(tempDealersList)
        })
    }

    const loadReportTypes = () => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        props.tokenSafeAPIRequest('/report/adjustment/report_types', requestOptions, '', (result) => {
            let tempReportTypes = []
            result.map((reportType) => {
                tempReportTypes.push({value: reportType, label: reportType})
            })
            console.log(tempReportTypes)
            setReportList(tempReportTypes)
        })
    }

    const loadAdmins = (id) => {
        //get dealers
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        props.tokenSafeAPIRequest('/dealership/' + id + '?fetch_links=True', requestOptions, '', (result) => {
            console.log(result)
            let tempAdminList = []
            result.admin_IDs.map((admin, index) => {
                tempAdminList.push({value: admin?.id, label: admin.name})
            })
            onChange({value: result.subagent_owner_ID?.id, label: result.subagent_owner_ID?.first_name + ' ' + result.subagent_owner_ID?.last_name}, 'subagent') //loads subagent owner
            setAllAdmins(tempAdminList)
        })
    }

    const loadContractTypes = (id) => {
        if (id === '')
        {

        }
        else
        {
            var myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
            myHeaders.append("Content-Type", "application/json");
    
            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
            };
    
            props.tokenSafeAPIRequest('/admin/' + id, requestOptions, '', (result) => {
                console.log(result)
                let tempContractTypeList = []
                result.VSC_contracts.map((contractType, index) => {
                    tempContractTypeList.push({value: {type: 'VSC', subType: contractType}, label: "VSC - " + contractType})
                })
                result.ancillary_contracts.map((contractType, index) => {
                    tempContractTypeList.push({value: {type: 'Ancillary', subType: contractType}, label: "Ancillary - " + contractType})
                })
    
                setAllContractTypes(tempContractTypeList)
            })
        }
    }

    useEffect(() => {
        calculateAmounts()
    },[data.spiffees, data.reserve_inputs, data.quantity])

    const calculateContractCount = (contractType, net) => {
        if (contractType.value.split(' - ')[0] === 'VSC')
        {
            return (net > 50 ? 1:net/50).toFixed(2)
        }
        else 
        {
            return (net/100).toFixed(2);
        }
    }

    const calculateTotalSpiffs = () => {
        let total = 0
        data.spiffees.map((spiff) => {
            total = total + Number.parseFloat(spiff.amount)
        })
        data.reserve_inputs.map((input) => {
            total = total + Number.parseFloat(input.amount)
        })
        return total;
    }

    const calculateAmounts = () => {
        let gross = props.saturdayReports[props.selectedReport].contract_gross;
        let NET = props.saturdayReports[props.selectedReport].net
        let IS = props.saturdayReports[props.selectedReport].inside_sales ? (NET):0
        let totalContractCount = props.saturdayReports[props.selectedReport].total_contract_count
        setReportSplits(
        {
            gross: gross,
            insideSales: IS,
            net: NET,
            contractCount: totalContractCount
        }
        )
    }

    const addSpiffee = (data) => {
        console.log(data)
        data = {
            spiffee: {value: data?.id, label: data.name},
            amount: data.amount,
            address: {value: data.address.value, label: data.address.label},
            spiff_type: data.spiffType,
            ATTN: data.ATTN,
            dealership_spiff: data?.id === 'dealership_spiff' ? true:false
        }
        setData((prevState) => ({
            ...prevState, // Spread the previous state to maintain other properties
            spiffees: [
                ...prevState.spiffees, // Spread the existing spiffees
                data
            ],
        }));
    }

    const addReserveInput = (data) => {
        console.log(data)
        data =  {
            account: {value: data?.id, label: data.account},
            amount: data.amount,
            reason: data.reason,
        }
        setData((prevState) => ({
            ...prevState, // Spread the previous state to maintain other properties
            reserve_inputs: [
                ...prevState.reserve_inputs, // Spread the existing spiffees
                data
            ],
        }));
    }

    const deleteSpiff = (indexToRemove) => {
        setData(prevState => {
            // Copy everything from the previous state except for the reserve_inputs array
            const newState = {
              ...prevState,
              spiffees: prevState.spiffees.filter((_, index) => index !== indexToRemove)
            };
          
            // Return the new state
            return newState;
        });
    }

    const deleteReserveInput = (indexToRemove) => {
        setData(prevState => {
            // Copy everything from the previous state except for the reserve_inputs array
            const newState = {
              ...prevState,
              reserve_inputs: prevState.reserve_inputs.filter((_, index) => index !== indexToRemove)
            };
          
            // Return the new state
            return newState;
        });
    }

    return (
        <div style={{paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px', display: 'flex', flexDirection: 'column', width: '1300px', height: 'auto'}}>
            <ModalManager colors={props.colors}>
                <AddSpiffee isOpen={addSpiffeeModal} setIsOpen={() => setAddSpiffeeModal(false)} addSpiffee={addSpiffee} colors={props.colors} selectedDealer={data.dealership} selectedSubagent={data.subagent} tokenSafeAPIRequest={props.tokenSafeAPIRequest}></AddSpiffee>
                <AddReserveInput colors={props.colors} isOpen={addReserveInputModal} setIsOpen={() => setAddReserveInputModal(false)} selectedDealer={data.dealership} selectedSubagent={data.subagent} addReserveInput={addReserveInput} tokenSafeAPIRequest={props.tokenSafeAPIRequest}></AddReserveInput>
            </ModalManager>
            <div style={{display: 'flex', flexDirection: 'row', height: '70px', paddingTop: '10px'}}>
                <span style={{fontWeight: '500', fontSize: '18px'}}>Selected Report</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px', marginLeft: 'auto'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            {data !== undefined ? <div style={{height: '350px', overflowY: 'auto'}}>
                <div style={{width: '100%', height: '110px'}}>
                    <div style={{width: '100%', height: '49px', backgroundColor: props.colors.block, borderTopRightRadius: '10px', borderTopLeftRadius: '10px', border: '1px solid ' + props.colors.border, display: 'flex', flexDirection: 'row'}}>
                        <div className='center' style={{width: '25%', height: '100%', borderRight: '1px solid ' + props.colors.border}}>
                            <span style={{fontWeight: '600'}}>Report Type</span>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%', borderRight: '1px solid ' + props.colors.border, borderLeft: '1px solid ' + props.colors.border}}>
                            <span style={{fontWeight: '600'}}>Dealer</span>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%', borderRight: '1px solid ' + props.colors.border, borderLeft: '1px solid ' + props.colors.border}}>
                            <span style={{fontWeight: '600'}}>Admin</span>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%', borderRight: '1px solid ' + props.colors.border, borderLeft: '1px solid ' + props.colors.border}}>
                            <span style={{fontWeight: '600'}}>Subagent</span>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%', borderLeft: '1px solid ' + props.colors.border}}>
                            <span style={{fontWeight: '600'}}>Contract Type</span>
                        </div>
                    </div>
                    <div style={{width: '100%', height: '58px', borderBottomRightRadius: '10px', borderBottomLeftRadius: '10px', border: '1px solid ' + props.colors.border, display: 'flex', flexDirection: 'row'}}>
                        <div className='center' style={{width: '25%', height: '100%'}}>
                            <Dropdown colors={props.colors} onChange={(e) => onChange(e, 'report_type')} indexParent={props.indexParent} data={reportList} width={195} value={data.report_type.label}></Dropdown>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%'}}>
                            <Dropdown colors={props.colors} onChange={(e) => onChange(e, 'dealership')} index={props.index} indexParent={props.indexParent} data={allDealers} width={195} value={data.dealership.label}></Dropdown>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%'}}>
                            <Dropdown colors={props.colors} onChange={(e) => onChange(e, 'admin')} indexParent={props.indexParent} data={allAdmins} width={195} value={data.admin.label}></Dropdown>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%'}}>
                            <span style={{fontWeight: '500'}}>{data.subagent.label}</span>
                        </div>
                        <div className='center' style={{width: '25%', height: '100%'}}>
                            <Dropdown colors={props.colors} onChange={(e) => onChange(e, 'contract_type')} indexParent={props.indexParent} data={allContractTypes} width={195} value={data.contract_type.label}></Dropdown>
                        </div>
                    </div>
                </div>
                <div style={{width: '100%', height: '110px', marginTop: '20px', display: 'flex', flexDirection: 'row'}}>
                    <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                        <div className='center' style={{height: '49px', backgroundColor: props.colors.block, border: '1px solid '+ props.colors.border, borderTopLeftRadius: '10px', display: 'flex', flexDirection: 'column'}}>
                            <span style={{fontWeight: '500'}}>Quantity</span>
                        </div>
                        <div className='center' style={{height: '58px', border: '1px solid '+ props.colors.border, width: '100%', borderBottomLeftRadius: '10px'}}>
                            <Counter allowNegative={false} onChange={(e) => onChange({value: e, label: e}, 'quantity')} indexParent={props.indexParent} colors={props.colors} index={props.index}>{data.quantity.value}</Counter>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                        <div className='center' style={{height: '49px', backgroundColor: props.colors.block, border: '1px solid '+ props.colors.border, display: 'flex', flexDirection: 'column', borderLeft: '0px'}}>
                            <span style={{fontWeight: '500'}}>Net</span>
                            <span style={{color: props.colors.muted}}>/ contract</span>
                        </div>
                        <div className='center' style={{height: '58px', border: '1px solid '+ props.colors.border, width: '100%', borderLeft: '0px'}}>
                            <TextInput prefix='$' onChange={(e) => onChange({value: e, label: e}, 'net')} index={props.index} indexParent={props.indexParent} colors={props.colors} data={data.net.value}></TextInput>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                        <div className='center' style={{height: '49px', backgroundColor: props.colors.block, border: '1px solid '+ props.colors.border, display: 'flex', flexDirection: 'column', borderLeft: '0px'}}>
                            <span style={{fontWeight: '500'}}>Inside Sales</span>
                            <span style={{color: props.colors.muted}}>/ contract</span>
                        </div>
                        <div className='center' style={{height: '58px', border: '1px solid '+ props.colors.border, width: '100%', borderLeft: '0px'}}>
                            <span>${data.inside_sales.value ? data.net.value:0}</span>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                        <div className='center' style={{height: '49px', backgroundColor: props.colors.block, border: '1px solid '+ props.colors.border, display: 'flex', flexDirection: 'column', borderLeft: '0px', borderTopRightRadius: '10px'}}>
                            <span style={{fontWeight: '500'}}>Contract Count</span>
                            <span style={{color: props.colors.muted}}>Total</span>
                        </div>
                        <div className='center' style={{height: '58px', border: '1px solid '+ props.colors.border, width: '100%', borderLeft: '0px', borderBottomRightRadius: '10px'}}>
                            <TextInput onChange={(e) => onChange({value: e, label: e}, 'contractCount')} index={props.index} indexParent={props.indexParent} colors={props.colors} data={data.contractCount.value}></TextInput>
                        </div>
                    </div>
                </div>
                <div className='noSelect' style={{display: 'flex', flexDirection: 'row', marginTop: '10px', width: 'auto'}}>
                    <div onClick={(e) => onChange({value: !data.inside_sales.value, label: !data.inside_sales.value}, 'inside_sales')} style={{cursor: 'pointer', width: '20px', height: '20px', border: data.inside_sales.value ? '2px solid ' + props.colors.primary:'2px solid ' + props.colors.border, borderRadius: '3px', backgroundColor: data.inside_sales.value ? props.colors.primary:''}}></div>
                    <span onClick={(e) => onChange({value: !data.inside_sales.value, label: !data.inside_sales.value}, 'inside_sales')} style={{marginLeft: '10px', cursor: 'pointer'}}>Apply to Inside Sales</span>
                </div>
            </div>:''}
            <Button onClick={() => props.editAdjustmentReport(data)} Style={{marginTop: '20px', width: '200px', marginLeft: 'auto'}} active={true} colors={props.colors}>Save</Button>
        </div>
    )
}

export default Main
